import { render, staticRenderFns } from "./factoryDes2.vue?vue&type=template&id=7efe6951&scoped=true"
import script from "./factoryDes2.vue?vue&type=script&lang=js"
export * from "./factoryDes2.vue?vue&type=script&lang=js"
import style0 from "./factoryDes2.vue?vue&type=style&index=0&id=7efe6951&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7efe6951",
  null
  
)

export default component.exports